// @flow

import { combineEpics, ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { switchMap, map, filter, catchError } from 'rxjs/operators';

import config from '../../config/app.config.js';
import { generateId, log } from '../../utils/CommonUtils';
import { REFRESH_TOKEN, REFRESH_TOKEN_DONE } from '../actions';
import type {
  CommonActions,
  MessageRequest,
  RefreshTokenParams,
  MessageResponse,
  RefreshTokenError,
  RefreshTokenResponse,
} from '../types';

const refreshTokenEpic = (action$: ActionsObservable<CommonActions>) =>
  action$.pipe(
    filter(action => action.type === REFRESH_TOKEN),
    switchMap((request) => {
      const json: MessageRequest<RefreshTokenParams> = {
        method: 'RefreshToken',
        params: {
          token: request.payload,
        },
        ts: Date.now(),
        ns: config.apiNSToken,
        id: generateId('RefreshToken'),
      };

      return ajax({
        url: config.refreshToken.url,
        type: 'POST',
        method: 'POST',
        body: JSON.stringify(json),
        dataType: 'json',
      }).pipe(
        map((ajaxResponse) => {
          log('response', ajaxResponse);

          const {
            response,
          }: {
            response: MessageResponse<RefreshTokenResponse, RefreshTokenError>
          } = ajaxResponse;

          const payload: RefreshTokenResponse = !response.error && response.result
            ? response.result
            : { token: null, expiration_time: -1 };

          return {
            type: REFRESH_TOKEN_DONE,
            payload,
          };
        }),
        catchError(() =>
          of({
            type: REFRESH_TOKEN_DONE,
            payload: { token: null, expiration_time: -1 },
          })),
      );
    }),
  );

export const commonEpics = combineEpics(refreshTokenEpic);
